export default{
    preferredBase: {
        Alert: {
            error: {
                title: 'Notice', // 错误提示标题
                text: 'Data request failed. Please try again.', // 错误信息
                buttonText: 'OK' // 确认按钮
            }
        },
        Description: {
        banner: {
            text1: 'Quality begins at the source', // 品质的源头
            text2: 'Starting with premium origins' // 始于优质的产地
        },
        module1: {
            item: {
                text1: 'Crop', // 作物
                text2: 'Area', // 面积
                text3: 'acres', // 亩（保留中文单位）
                text4: 'Annual Yield', // 年产量
                text5: 'kilograms', // 公斤
                text6: 'Annual Output Value', // 年产值
                text7: 'million CNY' // 万元
            }
        },
        module2: {
            tabs: [
                'Base Overview', // 基地介绍
                'Base Products', // 基地产品
                'Base Videos', // 基地视频
                'Environmental Monitoring' // 基地监测
            ],
            more: 'View More' // 查看更多
        }
        },
            Dialog: {
            title: 'Image' // 图片弹窗标题
        }
    }   
}